import request from "../../utils/request";
import { getTemplatePath } from "../../utils/string";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { toastSuccess } from "../../utils/toast";
import { getMerchant } from "../../utils/localStorage";
import { useMerchantStore } from "../../stores/merchant";
import { GET_BRAND, GET_BRANDS } from "../ApiKeyManagement/hooks";

const GET_MERCHANT_BY_ID = "/merchants/:merchantId";
const ADD_MERCHANT_SETTINGS = "/merchants/:merchantId/settings";
const ADD_BRAND_NOTIFICATION = "/merchants/:merchantId/brands/:brandId/settings";

const getMerchantById = () => {
  const merchant = getMerchant();
  return request.get(getTemplatePath(GET_MERCHANT_BY_ID, { merchantId: merchant?._id }));
};

const addMerchantSettings = async (payload) => {
  const merchant = getMerchant();
  return await request.put(
    getTemplatePath(ADD_MERCHANT_SETTINGS, { merchantId: merchant?._id }),
    payload
  );
};

const addBrandNotification = async ({ brandId, ...payload }) => {
  const merchant = getMerchant();
  return await request.patch(
    getTemplatePath(ADD_BRAND_NOTIFICATION, { merchantId: merchant?._id, brandId }),
    payload
  );
};

const uploadBrandLogo = async ({ brandId, formData }) => {
  const merchant = getMerchant();
  return await request.patch(
    getTemplatePath(ADD_BRAND_NOTIFICATION, { merchantId: merchant?._id, brandId }),
    formData
  );
};

const deleteBrandLogo = async ({ brandId }) => {
  const merchant = getMerchant();
  return await request.patch(
    getTemplatePath(ADD_BRAND_NOTIFICATION, { merchantId: merchant?._id, brandId }),
    { logo: null }
  );
};

export const useAddMerchantSettings = () => {
  const queryClient = useQueryClient();
  return useMutation(addMerchantSettings, {
    onSuccess: () => {
      queryClient.invalidateQueries([GET_MERCHANT_BY_ID]);
      toastSuccess({ description: "Change merchant  settings has been success" });
    },
  });
};

export const useGetMerchantById = () => {
  const merchant = getMerchant();
  const { setMerchant, setSelectedPreviewBrand } = useMerchantStore();
  return useQuery([GET_MERCHANT_BY_ID], getMerchantById, {
    enabled: !!merchant?._id,
    onSuccess: (data) => {
      setMerchant(data);
      // setSelectedPreviewBrand(data?.brands[0]?._id);
    },
  });
};

export const useAddBrandNotification = () => {
  const queryClient = useQueryClient();
  return useMutation(addBrandNotification, {
    onSuccess: (_data, { notificationUrl }) => {
      toastSuccess({
        description: notificationUrl
          ? "Webhook saved successfully"
          : "Webhook deleted successfully",
      });
      return Promise.all([
        queryClient.invalidateQueries([GET_MERCHANT_BY_ID]),
        queryClient.invalidateQueries([GET_BRANDS]),
        queryClient.invalidateQueries([GET_BRAND]),
      ]);
    },
  });
};

export const useUploadBrandLogo = () => {
  const queryClient = useQueryClient();
  return useMutation(uploadBrandLogo, {
    onSuccess: () => {
      queryClient.invalidateQueries([GET_MERCHANT_BY_ID]);
      queryClient.invalidateQueries([GET_BRANDS]);
      queryClient.invalidateQueries([GET_BRAND]);
      toastSuccess({ description: "Update brand logo has been success" });
    },
  });
};

export const useDeleteBrandLogo = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteBrandLogo, {
    onSuccess: () => {
      queryClient.invalidateQueries([GET_MERCHANT_BY_ID]);
      queryClient.invalidateQueries([GET_BRANDS]);
      queryClient.invalidateQueries([GET_BRAND]);
      toastSuccess({ description: "Delete brand logo has been success" });
    },
  });
};

export const useUpdateCashierTheme = () => {
  const queryClient = useQueryClient();
  return useMutation(addBrandNotification, {
    onSuccess: () => {
      queryClient.invalidateQueries([GET_MERCHANT_BY_ID]);
      queryClient.invalidateQueries([GET_BRANDS]);
      queryClient.invalidateQueries([GET_BRAND]);
    },
  });
};
